import { MemoryRouter, Outlet, Route, Routes, useLocation, useNavigate } from "react-router-dom";

import { ModalV2 } from "react-migration/components/ModalV2/ModalV2";
import { Button } from "react-migration/components/Button";

import { AddOnsStoreLandingPage } from "./pages/AddOnsStoreLandingPage";
import { GiveMyViewPage } from "./pages/other/GiveMyViewPage";
import { HometrackPage } from "./pages/general/HometrackPage";
import { LandFundPage } from "./pages/other/LandFundPage";
import { HOMETRACK_ADDON_ROUTE, LANDFUND_ADDON_ROUTE, GIVE_MY_VIEW_ADDON_ROUTE } from "./constants";

type AddOnsStoreModalProps = {
  onClose: () => void;
  initialPath?: string;
};

export const AddOnsStoreModal = ({ onClose, initialPath = "/" }: AddOnsStoreModalProps) => {
  return (
    <ModalV2.Root defaultOpen={true} onOpenChange={onClose}>
      <MemoryRouter basename="/" initialEntries={[initialPath]}>
        <Routes>
          <Route path="/" element={<AddOnsStoreModalTemplate />}>
            <Route index element={<AddOnsStoreLandingPage />} />
            <Route path={HOMETRACK_ADDON_ROUTE} element={<HometrackPage />} />
            <Route path={LANDFUND_ADDON_ROUTE} element={<LandFundPage />} />
            <Route path={GIVE_MY_VIEW_ADDON_ROUTE} element={<GiveMyViewPage />} />
          </Route>
        </Routes>
      </MemoryRouter>
    </ModalV2.Root>
  );
};

function AddOnsStoreModalTemplate() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const showBackButton = pathname !== "/";

  // Reset scroll position of the modal body when the pathname changes using key
  return (
    <ModalV2.Body
      key={pathname}
      className="z-1000!"
      contentClassName="md:max-h-[700px] overflow-y-auto"
      title="Add-ons"
      titleSlot={
        showBackButton && (
          <Button variant="tertiary" size="md" className="font-medium" onClick={() => navigate("/")}>
            <i className="icon-lt-arrow-left-line" /> Add-ons
          </Button>
        )
      }
    >
      <Outlet />
    </ModalV2.Body>
  );
}

AddOnsStoreModal.displayName = "AddOnsStoreModal";
